import { Button } from '@heroui/button';
import { MdTune } from 'react-icons/md';
import { Divider, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, TmdxSwitch, useDisclosure } from '@ds';
import { useCurrentUser } from '@lp/core/hooks/useCurrentUser';
import { useSetBoardSettings } from '@lp/core/hooks/useSetBoardSettings';
import { RowsReorderModal } from './RowsReorderModal';
import { CustomGroupsModal } from './CustomGroups';
import { UserPreferences } from '@/api/apis/user';

export const BoardSettings = () => {
  const { isOpen: isRearrangeOpen, onOpen: onRearrangeOpen, onOpenChange: onRearrangeOpenChange } = useDisclosure();
  const { isOpen: isOpenGroups, onOpen: onOpenGroups, onOpenChange: onOpenChangeGroups } = useDisclosure();
  const { hideEmpty, showGroups, groupsOrdered, setBoardPreferences } = useSetBoardSettings();
  const disabledKeys = groupsOrdered.length ? [] : ['showGroups'];
  const { updateUserPreferences } = useCurrentUser();

  const toggleHideEmpty = () => {
    setBoardPreferences({ hideEmpty: !hideEmpty });
    updateUserPreferences([{ name: UserPreferences.hideEmpty, value: JSON.stringify(!hideEmpty) }]);
  };

  const toggleShowGroups = () => {
    setBoardPreferences({ showGroups: !showGroups });
    updateUserPreferences([{ name: UserPreferences.showGroups, value: JSON.stringify(!showGroups) }]);
  };

  return (
    <>
      <Dropdown placement="bottom-start" className="bg-base-60">
        <DropdownTrigger>
          <Button
            className="text-m-m! text-base-10 bg-base-55 h-8 data-[hover=true]:opacity-100! data-[hover=true]:bg-base-50 aria-expanded:opacity-100! aria-expanded:bg-base-50"
            radius="full"
            disableRipple
            endContent={<MdTune size={18} className="text-base-30" />}
          >
            Settings
          </Button>
        </DropdownTrigger>
        <DropdownMenu itemClasses={{ title: ['text-m-r!'] }} selectionMode="none" disabledKeys={disabledKeys}>
          <DropdownItem key="rearrange" onClick={onRearrangeOpen}>
            Rearrange Lanes
          </DropdownItem>
          <DropdownItem key="customGroup" onClick={onOpenGroups}>
            Create Custom Group
          </DropdownItem>
          <DropdownItem key="divider" className="pointer-events-none">
            <Divider />
          </DropdownItem>
          <DropdownItem
            key="hideEmpty"
            onClick={toggleHideEmpty}
            endContent={<TmdxSwitch isSelected={hideEmpty} size="sm" onValueChange={toggleHideEmpty} />}
          >
            Hide Empty Lanes
          </DropdownItem>
          <DropdownItem
            key="showGroups"
            onClick={toggleShowGroups}
            endContent={<TmdxSwitch isSelected={showGroups} size="sm" onValueChange={toggleShowGroups} />}
          >
            Apply Custom Groups
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      {isRearrangeOpen && <RowsReorderModal onOpenChange={onRearrangeOpenChange} />}
      {isOpenGroups && <CustomGroupsModal onOpenChange={onOpenChangeGroups} />}
    </>
  );
};
